import Api from './rest/CrmFunnelApi';

export default new Api();
